import { getApiData } from "../api/api";
import AxiosRequest from "../utils/axios";
import { ROUTES, TELEBINDING_STAGES, TELEBINDING_WAITING_STAGES } from "../utils/constants";
import { getRedirectionRouteForPosv } from "../utils/handleProgress";

const axios = new AxiosRequest().getClient();

export const getTelebindingStageStatus = (router = null, isOtpScreen = false) => {
    return new Promise(async(resolve, reject) => {
        try {
            const { url, body} = getApiData("tbcheckstatus")
            body.request.payload.posvRefNumber=localStorage.getItem("posvRefNumber")
            body.request.payload.teleBStage= sessionStorage.getItem("tbStageOnOtp")
            const response = await axios.post(url, body)
            console.log({response})
            
            if(response?.data?.response?.payload?.teleBStage) {
                const currentStage = response?.data?.response?.payload?.teleBStage;
                if(router && !isOtpScreen && !TELEBINDING_WAITING_STAGES.includes(currentStage)) {
                    let url = "";
                    if(currentStage === TELEBINDING_STAGES.POSV) {
                        url = getRedirectionRouteForPosv();
                    }

                    if(currentStage === TELEBINDING_STAGES.PAYMENT) {
                        url = ROUTES.PAYMENT
                    }

                    if(currentStage === TELEBINDING_STAGES.PII) {
                        url = ROUTES.PERSONAL_DETAILS
                    }

                    router.push(url)
                } else {
                    resolve({ telebindingStatus: response?.data?.response?.payload?.teleBStage })
                }
            } else {
                reject({ businessMsg: response?.data?.response?.payload?.businessMsg ?? "Something went wrong."})
            }
            
        } catch (err) {
            reject({ businessMsg: "Something went wrong !", err})
        }
    })
}